import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import TableToExcel from '@linways/table-to-excel';
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
import CustomerAssessmentNoteViewPage from './CustomerAssessmentNoteViewPage';
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const DisbursementMemoPage = (props) => {
 // const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,formCAMValues,anchorCategories,speciallyAbledArr ,handleCAMChange,residenceTypesArr,bankingUpiArr,constitutionArr,customerTypeArr, vehicleMakerArr ,vehicleUseArr ,insuranceArr ,vehicleModelsArr ,camTotalPFAmount ,coapplicantGuarantorRows ,handleInputChange ,businessValidationProofArr ,turnoverIncomeArr ,workingCapitalCycleArr ,accountTypeArr ,requirementOptions ,statusOptions ,normsMetOptions,cAMLTVPercentage ,cAMMarginMoney,camIRRExcludingPF, irrExcludingPF, totalValueCombine, totalAmountAsPerPerformInvoice} = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [file, setFile] = useState('');
  const [pfAmt, SetPfAmt] = useState('');
    
useEffect(() => {
 }, []);

 const downloadExcel = async () => {
             const table = document.getElementById('DynamicExcelFile');
     
             TableToExcel.convert(table, {
                 name: 'FI-Checklist.xlsx',
                 sheet: {
                     name: 'FI-Checklist',
                 },
             });
         };

  const [showEditDiv, setShowEditDiv] = useState(true);

  const handleToggle = () => {
    setShowEditDiv((prev) => !prev); 
  };   
  
  // section cam PF Amount.
  const totalPfAmt = formCAMValues.cam_pf * formCAMValues.irr_finance_amount;
  const camTotalAsset = formCAMValues.irr_no_of_assets_to_be_financed * formCAMValues.assets_chassis_cost_closed_body;
  const cAMLTVPercentage1 = (formCAMValues.irr_finance_amount / totalAmountAsPerPerformInvoice) * 100;
  const camMarginMoney1 = (totalValueCombine - formCAMValues.irr_finance_amount);

  return (
    <>



        <div className="row" >

           <div className="col-md-12 d-none" >
              <button
                    type="button"
                    className="btn btn-primary text-white" 
                    onClick={handleToggle}
                >
                    {showEditDiv ? 'View Format' : 'Edit Format'}
                </button>
            </div>  


            
              <div className= {showEditDiv ? "row":"row d-none"}>
                     
              <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_date">
                         <span>Date</span>
                         <input
                           type="date"
                           id='dmemo_date'
                           name='dmemo_date'
                           className='form-control'
                           {...register('dmemo_date')}
                           value={formCAMValues.dmemo_date}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                     <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_reference_no">
                         <span>Reference No</span>
                         <input
                           id='dmemo_reference_no'
                           name='dmemo_reference_no'
                           className='form-control'
                           {...register('dmemo_reference_no')}
                           value={formCAMValues.dmemo_reference_no}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_pre_emi_start_date">
                         <span>Pre EMi Start Date</span>
                         <input
                           type="date"
                           id='dmemo_pre_emi_start_date'
                           name='dmemo_pre_emi_start_date'
                           className='form-control'
                           {...register('dmemo_pre_emi_start_date')}
                           value={formCAMValues.dmemo_pre_emi_start_date}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_pre_emi_end_date">
                         <span>Pre EMi End Date</span>
                         <input
                           type="date"
                           id='dmemo_pre_emi_end_date'
                           name='dmemo_pre_emi_end_date'
                           className='form-control'
                           {...register('dmemo_pre_emi_end_date')}
                           value={formCAMValues.dmemo_pre_emi_end_date}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_agreement_no">
                         <span>Agreement No</span>
                         <input
                           id='dmemo_agreement_no'
                           name='dmemo_agreement_no'
                           className='form-control'
                           {...register('dmemo_agreement_no')}
                           value={formCAMValues.dmemo_agreement_no}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_sourcing_agency">
                         <span>Sourcing Agency</span>
                         <input
                           id='dmemo_sourcing_agency'
                           name='dmemo_sourcing_agency'
                           className='form-control'
                           {...register('dmemo_sourcing_agency')}
                           value={formCAMValues.dmemo_sourcing_agency}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_customer_name">
                         <span>Name Of Customer</span>
                         <input
                           id='dmemo_customer_name'
                           name='dmemo_customer_name'
                           className='form-control'
                           {...register('dmemo_customer_name')}
                           value={formCAMValues.dmemo_customer_name}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_guarantor_name">
                         <span>Name Of Guarantor</span>
                         <input
                           id='dmemo_guarantor_name'
                           name='dmemo_guarantor_name'
                           className='form-control'
                           {...register('dmemo_guarantor_name')}
                           value={formCAMValues.dmemo_guarantor_name}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_guarantor_name_2">
                         <span>Name Of Guarantor</span>
                         <input
                           id='dmemo_guarantor_name_2'
                           name='dmemo_guarantor_name_2'
                           className='form-control'
                           {...register('dmemo_guarantor_name_2')}
                           value={formCAMValues.dmemo_guarantor_name_2}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_vehicle_models">
                         <span>Vehicle And Model</span>
                         <input
                           id='dmemo_vehicle_models'
                           name='dmemo_vehicle_models'
                           className='form-control'
                           {...register('dmemo_vehicle_models')}
                           value={formCAMValues.dmemo_vehicle_models}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>


                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_no_of_asset">
                         <span>No. of Asset</span>
                         <input
                           id='dmemo_no_of_asset'
                           name='dmemo_no_of_asset'
                           type="number"
                           className='form-control'
                           {...register('dmemo_no_of_asset')}
                          //  value={formCAMValues.dmemo_no_of_asset}
                          value={formCAMValues.dmemo_no_of_asset}
                           onChange={handleCAMChange} 
                         />
                         </label>
                       </div>
                       </div>



                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_insurance_by_cfpl" title="Picking value from CAM Assets details tab">
                         <span>Insurance by CFPL</span>
                         <input
                           id='dmemo_insurance_by_cfpl'
                           name='dmemo_insurance_by_cfpl'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_insurance_by_cfpl')}
                           value={formCAMValues.dmemo_insurance_by_cfpl}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       
                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_insurance_by_dealer">
                         <span>Insurance by Dealer</span>
                         <input
                           id='dmemo_insurance_by_dealer'
                           name='dmemo_insurance_by_dealer'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_insurance_by_dealer')}
                           value={formCAMValues.dmemo_insurance_by_dealer}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div> 

                       


                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_invoice_price_per_vehicle" title="Picking value from CAM Assets details tab : (Chassis Cost - Closed Body + Chassis Cost -Open Body)">
                         <span>Chasis Amount</span>
                         <input
                           id='dmemo_invoice_price_per_vehicle'
                           name='dmemo_invoice_price_per_vehicle'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_invoice_price_per_vehicle')}
                           value={formCAMValues.dmemo_invoice_price_per_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>


                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_invoice_price_all_vehicle">
                         <span title=" Chasis Amount * No. of Asset">Chasis Amount- ( All Vehicles )</span>
                         <input
                           id='dmemo_invoice_price_all_vehicle'
                           name='dmemo_invoice_price_all_vehicle'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_invoice_price_all_vehicle')}
                           value={formCAMValues.dmemo_invoice_price_all_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_total_cost_per_vehicle">
                         <span title="“Total Asset Price” from IRR sheet">Total Cost per vehicle</span>
                         <input
                           id='dmemo_total_cost_per_vehicle'
                           name='dmemo_total_cost_per_vehicle'
                           type="number"
                            readOnly="true"
                           className='form-control'
                           {...register('dmemo_total_cost_per_vehicle')}
                           value={formCAMValues.dmemo_total_cost_per_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_margin_money_vehicle">
                         <span>Margin Money - Vehicle</span>
                         <input
                           id='dmemo_margin_money_vehicle'
                           name='dmemo_margin_money_vehicle'
                           type="number"
                           className='form-control'
                           {...register('dmemo_margin_money_vehicle')}
                           value={formCAMValues.dmemo_margin_money_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_margin_money_all_vehicle">
                         <span title="Margin Money - Vehicle * No. of Asset">Margin Money - ( All Vehicles )</span>
                         <input
                           id='dmemo_margin_money_all_vehicle'
                           name='dmemo_margin_money_all_vehicle'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_margin_money_all_vehicle')}
                           value={formCAMValues.dmemo_margin_money_all_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                      

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_funding_per_vehicle">
                         <span title="Total Cost per vehicle- Margin Money (Vehicle)">Funding Per Vehicle</span>
                         <input
                           id='dmemo_funding_per_vehicle'
                           name='dmemo_funding_per_vehicle'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_funding_per_vehicle')}
                           value={formCAMValues.dmemo_funding_per_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_loan_amount" title="Funding Per Vehicle * No. of Asset">
                         <span>Loan Amount</span>
                         <input
                           id='dmemo_loan_amount'
                           name='dmemo_loan_amount'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_loan_amount')}
                           value={formCAMValues.dmemo_loan_amount}
                           onChange={handleCAMChange}  
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_flat_rate">
                         <span>Flat Rate</span>
                         <input
                           id='dmemo_flat_rate'
                           name='dmemo_flat_rate'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_flat_rate')}
                           value={formCAMValues.dmemo_flat_rate}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_irr">
                         <span>IRR</span>
                         <input
                           id='dmemo_irr'
                           name='dmemo_irr'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_irr')}
                           value={formCAMValues.dmemo_irr}
                           onChange={handleCAMChange} 
                                                    
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3 '>
                       <div className=' row'> 
                       <div className='col-md-6 '>
                       <div className='form-group'>
                        <label htmlFor="dmemo_pre_emi_type">
                         <span >Pre-EMI Type</span>
                         <select 
                         name='dmemo_pre_emi_type'
                         id='dmemo_pre_emi_type'  
                         className="form-select" 
                         {...register('dmemo_pre_emi_type')}
                         value={formCAMValues.dmemo_pre_emi_type}
                         onChange={handleCAMChange}>
                              <option value="Upfront Collection">Upfront Collection</option>
                              <option value="Merge with EMI">Merge with EMI</option>
                              <option value="No Pre EMI">No Pre EMI</option>
                              <option value="Collect Later">Collect Later</option>
                          </select>
                          
                        </label>
                        </div>
                       </div>

                        <div className='col-md-6 '>
                        <div className='form-group'>
                         <label htmlFor="dmemo_pre_emi">
                         <span title=" ROUNDUP(Funding Per Vehicle * IRR /360*(Pre EMi Start Date - Pre EMi End Date),0) ">Pre-Emi</span>
                         
                         <input
                           id='dmemo_pre_emi'
                           name='dmemo_pre_emi'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_pre_emi')}
                           value={formCAMValues.dmemo_pre_emi}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                         </div>
                         </div>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_processing_fee_on_finance_amount_plus_gst">
                         <span>Processing Fee (%)  </span>
                         <input
                           id='dmemo_processing_fee_on_finance_amount_plus_gst'
                           name='dmemo_processing_fee_on_finance_amount_plus_gst'
                           type="number"
                           className='form-control'
                           {...register('dmemo_processing_fee_on_finance_amount_plus_gst')}
                           value={formCAMValues.dmemo_processing_fee_on_finance_amount_plus_gst}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>


                       <div className='col-md-3'>

<div className=' row'> 
                       <div className='col-md-5 ' style={{ paddingRight: '0px' }}>
                       <div className='form-group'>
                        <label htmlFor="dmemo_processing_fee_including_gst_type">
                         <span >PF Type</span>
                         <select 
                         name='dmemo_processing_fee_including_gst_type'
                         id='dmemo_processing_fee_including_gst_type' 
                         className="form-select" 
                         {...register('dmemo_processing_fee_including_gst_type')}
                         value={formCAMValues.dmemo_processing_fee_including_gst_type}
                         onChange={handleCAMChange}>
                              <option value="Upfront Collection">Upfront Collection</option>
                              <option value="Funded with LA">Funded with LA</option>
                               
                           </select>
                          
                        </label>
                        </div>
                       </div>
                       
                        <div className='col-md-7 ' style={{ paddingLeft: '0px' }}>
                        <div className='form-group'>
                         <label htmlFor="dmemo_processing_fee_including_gst">
                         <span>Processing Fee (Including GST)</span>
                         <input
                           id='dmemo_processing_fee_including_gst'
                           name='dmemo_processing_fee_including_gst'
                           type="number"
                           className='form-control'
                           {...register('dmemo_processing_fee_including_gst')}
                           value={formCAMValues.dmemo_processing_fee_including_gst}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                         </div>
                       </div>
                       </div>


                       <div className='col-md-3 '>
                       <div className=' row'> 
                       <div className='col-md-6 '>
                       <div className='form-group'>
                        <label htmlFor="dmemo_kli_amount_type">
                         <span >CLI Type</span>
                         <select 
                         name='dmemo_kli_amount_type'
                         id='dmemo_kli_amount_type' 
                         className="form-select" 
                         {...register('dmemo_kli_amount_type')}
                         value={formCAMValues.dmemo_kli_amount_type}
                         onChange={handleCAMChange}>
                              <option value="Upfront Collection">Upfront Collection</option>
                              <option value="Funded with LA">Funded with LA</option>
                              <option value="NA">NA</option>
                           </select>
                          
                        </label>
                        </div>
                       </div>

                        <div className='col-md-6 '>
                        <div className='form-group'>
                         <label htmlFor="dmemo_kli_amount">
                         <span title=" CAM -> KOTAK LI AMOUNT">CLI Amount</span>
                         
                         <input
                           id='dmemo_kli_amount'
                           name='dmemo_kli_amount'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_kli_amount')}
                           value={formCAMValues.dmemo_kli_amount}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                         </div>
                         </div>
                       </div>
                       </div>

                       <div className='col-md-3'>

                  <div className=' row'> 
                       <div className='col-md-6 '>
                       <div className='form-group'>
                        <label htmlFor="dmemo_file_charge_type">
                         <span >File Charge Type</span>
                         <select 
                         name='dmemo_file_charge_type'
                         id='dmemo_file_charge_type' 
                         className="form-select" 
                         {...register('dmemo_file_charge_type')}
                         value={formCAMValues.dmemo_file_charge_type}
                         onChange={handleCAMChange}>
                              <option value="Upfront Collection">Upfront Collection</option>
                              <option value="Funded with LA">Funded with LA</option>
                           </select>
                          
                        </label>
                        </div>
                       </div>
                       
                        <div className='col-md-6 '>
                       <div className='form-group'>
                         <label htmlFor="dmemo_file_charge">
                         <span>File Charge</span>
                         <input
                           id='dmemo_file_charge'
                           name='dmemo_file_charge'
                           type="number"
                           readOnly="true"
                           className='form-control'
                           {...register('dmemo_file_charge')}
                           value={formCAMValues.dmemo_file_charge}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                        </div>
                         </div>
                       </div>
                       </div>
                      

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_total_down_payment_by_customer">
                         <span title="((Total Cost per vehicle *  No of Assets )- Loan Amount+ Upfront Collection of File charges+ Upfront Collections of Pre EMI + Upfront collections of KLI+ Processing charges including GST)">Total down payment by Customer ( Incuding PF and Other Charges)</span>
                         <input
                           id='dmemo_total_down_payment_by_customer'
                           name='dmemo_total_down_payment_by_customer'
                           type="number"
                           className='form-control'
                           {...register('dmemo_total_down_payment_by_customer')}
                           value={formCAMValues.dmemo_total_down_payment_by_customer}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_ltv">
                         <span>LTV</span>
                         <input
                           id='dmemo_ltv'
                           name='dmemo_ltv'
                           type="number"
                           className='form-control'
                           {...register('dmemo_ltv')}
                           value={formCAMValues.dmemo_ltv}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_tenure">
                         <span>Tenure</span>
                         <input
                           id='dmemo_tenure'
                           name='dmemo_tenure'
                           type="number"
                           className='form-control'
                           {...register('dmemo_tenure')}
                           value={formCAMValues.dmemo_tenure}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_emi_per_vehicle">
                         <span>EMI Per Vehicle</span>
                         <input
                           id='dmemo_emi_per_vehicle'
                           name='dmemo_emi_per_vehicle'
                           type="number"
                           className='form-control'
                           {...register('dmemo_emi_per_vehicle')}
                           value={formCAMValues.dmemo_emi_per_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_emi_all_vehicle">
                         <span>EMI (All Vehicles)</span>
                         <input
                           id='dmemo_emi_all_vehicle'
                           name='dmemo_emi_all_vehicle'
                           type="number"
                           className='form-control'
                           {...register('dmemo_emi_all_vehicle')}
                           value={formCAMValues.dmemo_emi_all_vehicle}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_scheme">
                         <span>Scheme</span>
                         <input
                           id='dmemo_scheme'
                           name='dmemo_scheme'
                           className='form-control'
                           {...register('dmemo_scheme')}
                           value={formCAMValues.dmemo_scheme}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_no_of_advance_emi">
                         <span>No Of Advance EMI's</span>
                         <input
                           id='dmemo_no_of_advance_emi'
                           name='dmemo_no_of_advance_emi'
                           type="number"
                           className='form-control'
                           {...register('dmemo_no_of_advance_emi')}
                           value={formCAMValues.dmemo_no_of_advance_emi}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       


                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_stamp_duty">
                         <span>Stamp Duty</span>
                         <input
                           id='dmemo_stamp_duty'
                           name='dmemo_stamp_duty'
                           type="number"
                           className='form-control'
                           {...register('dmemo_stamp_duty')}
                           value={formCAMValues.dmemo_stamp_duty}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_directs_ource_charges">
                         <span>Direct Source Charges</span>
                         <input
                           id='dmemo_directs_ource_charges'
                           name='dmemo_directs_ource_charges'
                           type="number"
                           className='form-control'
                           {...register('dmemo_directs_ource_charges')}
                           value={formCAMValues.dmemo_directs_ource_charges}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>


                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_dealer_subvention">
                         <span>Dealer Subvention</span>
                         <input
                           id='dmemo_dealer_subvention'
                           name='dmemo_dealer_subvention'
                           type="number"
                           className='form-control'
                           {...register('dmemo_dealer_subvention')}
                           value={formCAMValues.dmemo_dealer_subvention}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>
                       

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_disbursement_date">
                         <span>Disbursement Date</span>
                         <input
                           type="date"
                           id='dmemo_disbursement_date'
                           name='dmemo_disbursement_date'
                           className='form-control'
                           {...register('dmemo_disbursement_date')}
                           value={formCAMValues.dmemo_disbursement_date}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_first_emi_interest_date">
                         <span>First EMI Interest Start Date</span>
                         <input
                           type="date"
                           id='dmemo_first_emi_interest_date'
                           name='dmemo_first_emi_interest_date'
                           className='form-control'
                           {...register('dmemo_first_emi_interest_date')}
                           value={formCAMValues.dmemo_first_emi_interest_date}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                     
                      

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_disbursement_amount_for_vehicle_including_box">
                         <span title="Loan Amount - Processing Fee (Including GST) - Insurance by CFPL - Pre-Emi  - File Charge">Disbursement Amount For Vehicle Including Box</span>
                         <input
                           id='dmemo_disbursement_amount_for_vehicle_including_box'
                           name='dmemo_disbursement_amount_for_vehicle_including_box'
                           type="number"
                           className='form-control'
                           {...register('dmemo_disbursement_amount_for_vehicle_including_box')}
                           value={formCAMValues.dmemo_disbursement_amount_for_vehicle_including_box}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_disbursement_in_vehicle_in_favour_of">
                         <span>Disbursement In Vehicle in Favour of</span>
                         <input
                           id='dmemo_disbursement_in_vehicle_in_favour_of'
                           name='dmemo_disbursement_in_vehicle_in_favour_of'
                            readOnly="true"
                           className='form-control'
                           {...register('dmemo_disbursement_in_vehicle_in_favour_of')}
                           value={formCAMValues.dmemo_disbursement_in_vehicle_in_favour_of}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_bank_name">
                         <span>Bank Name</span>
                         <input
                           id='dmemo_bank_name'
                           name='dmemo_bank_name'
                            readOnly="true"
                           className='form-control'
                           {...register('dmemo_bank_name')}
                           value={formCAMValues.dmemo_bank_name}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_account_no">
                         <span>Account No</span>
                         <input
                           id='dmemo_account_no'
                           name='dmemo_account_no'
                            readOnly="true"
                           className='form-control'
                           {...register('dmemo_account_no')}
                           value={formCAMValues.dmemo_account_no}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_ifsc_code">
                         <span>IFSC Code</span>
                         <input
                           id='dmemo_ifsc_code'
                           name='dmemo_ifsc_code'
                            readOnly="true"
                           className='form-control'
                           {...register('dmemo_ifsc_code')}
                           value={formCAMValues.dmemo_ifsc_code}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_signature_of_operations">
                         <span>SIGNATURE OF OPERATIONS</span>
                         <input
                           id='dmemo_signature_of_operations'
                           name='dmemo_signature_of_operations'
                           className='form-control'
                           {...register('dmemo_signature_of_operations')}
                           value={formCAMValues.dmemo_signature_of_operations}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_maker_by">
                         <span>Maker by </span>
                         <input
                           id='dmemo_maker_by'
                           name='dmemo_maker_by'
                           className='form-control'
                           {...register('dmemo_maker_by')}
                           value={formCAMValues.dmemo_maker_by}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_authorised_by">
                         <span>Authorised by  </span>
                         <input
                           id='dmemo_authorised_by'
                           name='dmemo_authorised_by'
                           className='form-control'
                           {...register('dmemo_authorised_by')}
                           value={formCAMValues.dmemo_authorised_by}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                      

                       <div className='col-md-3 d-none'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_less_pre_emi_till_5th_jan">
                         <span>Less: Pre-EMI Till 5TH JAN  </span>
                         <input
                           id='dmemo_less_pre_emi_till_5th_jan'
                           name='dmemo_less_pre_emi_till_5th_jan'
                           type="number"
                           className='form-control'
                           {...register('dmemo_less_pre_emi_till_5th_jan')}
                           value={formCAMValues.dmemo_less_pre_emi_till_5th_jan}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3 d-none'>
                       <div className='form-group'>
                         <label htmlFor="dmemo_net_disbursement">
                         <span>Net Disbursement  </span>
                         <input
                           id='dmemo_net_disbursement'
                           name='dmemo_net_disbursement'
                           type="number"
                           className='form-control'
                           {...register('dmemo_net_disbursement')}
                           value={formCAMValues.dmemo_net_disbursement}
                           onChange={handleCAMChange}                           
                         />
                         </label>
                       </div>
                       </div>
                       
                       
                       
                       
                       
                       
 
 
  
  
    

 </div>

 
        <div className= {showEditDiv ? "row d-none":"row"}>
            <CustomerAssessmentNoteViewPage
                                       leadInfo={leadInfo}
                                       formCAMValues={formCAMValues}
                                       anchorCategories={anchorCategories} 
                                       speciallyAbledArr={speciallyAbledArr}
                                       handleCAMChange ={handleCAMChange}  
                                       residenceTypesArr ={residenceTypesArr}  
                                       bankingUpiArr ={bankingUpiArr} 
                                       constitutionArr={constitutionArr} 
                                       customerTypeArr={customerTypeArr} 
                                       vehicleMakerArr={vehicleMakerArr} 
                                       vehicleUseArr={vehicleUseArr} 
                                       insuranceArr={insuranceArr} 
                                       vehicleModelsArr={vehicleModelsArr} 
                                       setCamTotalPFAmount={props.setCamTotalPFAmount} 
                                       camTotalPFAmount={camTotalPFAmount} 
                                       coapplicantGuarantorRows={coapplicantGuarantorRows}
                                       handleInputChange={handleInputChange}  
                                       businessValidationProofArr={businessValidationProofArr}  
                                       turnoverIncomeArr= {turnoverIncomeArr} 
                                       workingCapitalCycleArr={workingCapitalCycleArr}  
                                       accountTypeArr={accountTypeArr} 
                                       requirementOptions={requirementOptions} 
                                       statusOptions={statusOptions}  
                                       normsMetOptions={normsMetOptions}  
                                       setCAMLTVPercentage={props.setCAMLTVPercentage} 
                                       cAMLTVPercentage={cAMLTVPercentage}
                                       setCAMMarginMoney={props.setCAMMarginMoney}   
                                       cAMMarginMoney={cAMMarginMoney} 
                                       setCamIRRExcludingPF={props.setCamIRRExcludingPF}   
                                       camIRRExcludingPF={camIRRExcludingPF}
                                       irrExcludingPF={irrExcludingPF}
                                       totalValueCombine={totalValueCombine}
                                       totalAmountAsPerPerformInvoice={totalAmountAsPerPerformInvoice}
                                       cAMLTVPercentage1={cAMLTVPercentage1}
                                       camMarginMoney1={camMarginMoney1}
                                      />
        </div>
      </div>


    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DisbursementMemoPage);
